import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { UserStatusEnum } from 'src/app/admin-panel/enums/user-status.enum';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { AppUserModel } from 'src/app/admin-panel/models/members/app-user.model';
import { SearchAppUserModel } from 'src/app/admin-panel/models/members/search-app-user.model';
import { AppUserService } from 'src/app/admin-panel/services/members/app-user.service';
import { ArchiveAppUserComponent } from './archive-app-user/archive-app-user.component';
import { DetailsAppUserComponent } from './details-app-user/details-app-user.component';
import { TranslateService } from '@ngx-translate/core';
import { ProjectId } from "../../../enums/project-id.enum";
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-app-users',
  templateUrl: './app-users.component.html',
  styleUrls: ['./app-users.component.scss']
})
export class AppUsersComponent implements OnInit {

  //#region Fields
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  public src_drop_opt: Array<DropdownHelperModel>;
  public src_drop_opt_1: DropdownHelperModel;
  public src_drop_opt_2: DropdownHelperModel;
  public selected_drop_opt: DropdownHelperModel;
  public totalPages: number;
  public totalRecords: number;
  public unsubscribe: Subject<void> = new Subject<void>();
  public searchAppUserModel: SearchAppUserModel = new SearchAppUserModel();
  public spinner : boolean=false;
  public appUserList : Array<AppUserModel>;
  public activeSubscribers :number;
  public suspendedSubscribers : number;
  public selectedApp: ProjectId = ProjectId.SocialiteEvents;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public appUserService : AppUserService,
    public translate: TranslateService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.src_drop_opt = new Array<DropdownHelperModel>();
    this.src_drop_opt_1 = new DropdownHelperModel()
    this.src_drop_opt_1.id = '1';
    this.src_drop_opt_1.name = 'A_Z';
    this.src_drop_opt_2 = new DropdownHelperModel()
    this.src_drop_opt_2.id = '2';
    this.src_drop_opt_2.name = 'Z_A';
    this.src_drop_opt.push(this.src_drop_opt_1);
    this.src_drop_opt.push(this.src_drop_opt_2);


    this.appUserList = new Array<AppUserModel>();
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      this.selectedApp = +params['appId'] as ProjectId;
      this.searchAppUserModel.pageNumber = 1;
      this.appUserList = new Array<AppUserModel>();
      this.getallsubscibers(this.searchAppUserModel);
    });
  }
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  //#endregion
  //#region Public Methods
  getallsubscibers(searchModel: SearchAppUserModel) {
    this.spinner=true;
    const apiCall = this.getApiCallFunction(this.selectedApp, searchModel);

    apiCall.pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          if (response) {
            this.totalPages = response.totalPages;
            this.totalRecords = response.extendedData.totalActiveSubscribers + response.extendedData.totalSuspendedSubscribers;
            this.activeSubscribers = response.extendedData.totalActiveSubscribers;
            this.suspendedSubscribers = response.extendedData.totalSuspendedSubscribers;
            if (this.searchAppUserModel.pageNumber > 1) {
              this.appUserList = this.appUserList.concat(response.data)
            }
            else {
              this.appUserList = response.data;
            }
          } else {
            this.totalPages = this.totalRecords = this.activeSubscribers = this.suspendedSubscribers = 0;
          }
          this.spinner=false;
        },
        error: errorResponse => {
          this.spinner=false;
        }
      });

  };
  loadMoreAppUser(){
    this.searchAppUserModel.pageNumber = this.searchAppUserModel.pageNumber + 1;
    this.getallsubscibers(this.searchAppUserModel);
  }
  detailsAppUser(id:string){
    const ref = this.dialogService.open(DetailsAppUserComponent, {
      data: {
        id: id
      },
      // header: 'Details App User',
      width: '450px',
      styleClass: 'ml_200, mb_15 header_color'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  suspendedAppUser(id:string){
    const ref = this.dialogService.open(ArchiveAppUserComponent, {
      data: {
        id: id,
        active:true
      },
      header: this.translate.instant('MEMBERS.SUSPEND_APP_USER'),
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAppUserModel.pageNumber = 1;
        this.getallsubscibers(this.searchAppUserModel);
        let summary = this.translate.instant('MEMBERS.USER_SUSPENDED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  unsuspendedAppUser(id:string){
    const ref = this.dialogService.open(ArchiveAppUserComponent, {
      data: {
        id: id,
        active:false
      },
      header: this.translate.instant('MEMBERS.UNSUSPEND_APP_USER'),
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAppUserModel.pageNumber = 1;
        this.getallsubscibers(this.searchAppUserModel);
        let summary = this.translate.instant('MEMBERS.USER_UNSUSPENDED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }

  searhSubscibers(searchModel: SearchAppUserModel) {
    if(this.selected_drop_opt.id == '1'){
      searchModel.asc = true;
    } else if(this.selected_drop_opt.id == '2') {
      searchModel.asc = false;
    }
    searchModel.pageNumber = 1;
    this.getallsubscibers(searchModel)
  }
  clearSearch() {
    this.searchAppUserModel.city="";
    this.searchAppUserModel.name="";
    this.getallsubscibers(this.searchAppUserModel);
  }
  changeSortBy(){
    this.searhSubscibers(this.searchAppUserModel);
  }
  changeTabView(event:any){
      if(event.index ==2){
    this.searchAppUserModel.status=UserStatusEnum.Suspended;
    this.searchAppUserModel.pageNumber=1;
   }
   if(event.index ==1){
    this.searchAppUserModel.status=UserStatusEnum.Active;
    this.searchAppUserModel.pageNumber=1;
   }
   if(event.index ==0){
    this.searchAppUserModel.status=UserStatusEnum.All;
    this.searchAppUserModel.pageNumber=1;
   }
   this.getallsubscibers(this.searchAppUserModel);
  }
  //#endregion
  //#Private Methods
  private getApiCallFunction(projectId: ProjectId | string, model: SearchAppUserModel) {
    switch (projectId) {
      case ProjectId.SocialitePOS:
        return this.appUserService.getallposemployees(model);
      case ProjectId.SocialiteResy:
        return this.appUserService.getallresysubscribers(model);
      default:
        return this.appUserService.getalleventsubscibers(model);
    }
  }
  //#endregion
}
